
<mat-toolbar class="main-toolbar">
  <mat-toolbar-row style="padding-left: 0;">

      <div class="headerInset">
        <div class="zone zone-header">
          <span class="navbar-brand">
            <img alt="Ups-Logo" src="assets/images/UPS_Logo.png" class="img-responsive ups_logo">
          </span>
        </div>
      </div>

    <!-- <button mat-icon-button (click)="toggle('drawer')" aria-label="show menu">
      <mat-icon>more_vert</mat-icon>
    </button> -->

    <div class="title">{{title}}</div>

    <div *ngIf="showTaskBar" class="driverTasksDueInfoWrapper" (click)="openPanel('myTasks')">
      <div class="task-container">
        <div class="icon-pickup-large"></div>
        <div class="driverTasksDueInfoBigText">{{driverTasksDueInfoBigText}}</div>
      </div>

      <div class="due-in-container">
        <div class="driverTasksDueInfoSmallText">First Stop<br>Due in</div>
        <div class="driverTasksDueInfoMinutes">
        <div [ngClass]="minsUntilDue[0] === 'EARLY' ? 'minWrapTaskBar' : 'minWrapLateTaskBar'">
          <div [ngClass]="minsUntilDue[0] === 'EARLY' ? 'minutesStyleTaskBar' : 'lateMinutesStyleTaskBar'">
            {{minsUntilDue[0] === 'LATE' ? '-' : ''}}{{minsUntilDue[1]}}
            <br>
            <span class="minutesTxt">{{minsUntilDue[2]}}</span>
          </div>
        </div>
        </div>
      </div>
    </div>

    <section class="profile-section">
      <button *appHasRole="['cvv_coordinator','cvv_driver']" mat-icon-button (click)="toggle('drawer1')" aria-label="Alerts">
        <mat-icon matBadge="{{meatballValue}}" matBadgeColor="warn" matTooltip="Alerts" [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="100" [matBadgeHidden]="!showMeatball" aria-hidden="false">warning</mat-icon>
      </button>

      <button [matMenuTriggerFor]="menu" mat-button aria-label="Account" class="account-button">
        <mat-icon>account_circle</mat-icon><span style="margin-left: 6px;">{{ accountName }}</span>
      </button>
    </section>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="logout()">
        <mat-icon class="material-icons-outlined">logout</mat-icon>
        <span>Log Off</span>
      </button>

      <!-- <button mat-menu-item>
        <mat-icon>notifications_off</mat-icon>
        <span>Disable alerts</span>
      </button> -->

      <!-- <button mat-menu-item  routerLink='/map'>
        <mat-icon class="material-icons-outlined">map</mat-icon>
        <span>Map</span>
      </button> -->

      <!-- <div mat-menu-item (click)="$event.stopPropagation();">
        <mat-icon>bedtime</mat-icon>
        <span style="margin-right:3px">Off</span>
        <mat-slide-toggle [formControl]="darkModeToggle" class="mr-8"></mat-slide-toggle>
        <span style="margin-left:3px">On</span>
      </div> -->

    </mat-menu>
  </mat-toolbar-row>

</mat-toolbar>
